import VpnKeyIcon from "@mui/icons-material/VpnKey";
import { BorderedIconButton } from "../../../appV2/components/BorderedIconButton";

interface ShareCredentialsChatButtonProps {
  isLoading: boolean;
  handleClick: () => void;
  visible: boolean;
  tooltip: string;
}

export function ShareCredentialsChatButton(props: ShareCredentialsChatButtonProps) {
  const { tooltip, handleClick, visible, isLoading } = props;

  if (!visible) {
    return null;
  }

  return (
    <BorderedIconButton disabled={isLoading} tooltip={tooltip} onClick={handleClick}>
      <VpnKeyIcon />
    </BorderedIconButton>
  );
}
